import {Injectable} from '@angular/core';

import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

import {Util} from "../app/util";
import {CONFIG} from "../app/config";
import {TConsumoFlag, TFinanceSide, TPaymentFlag} from "../app/enum";

import {WebIntent, IntentOptions } from '@ionic-native/web-intent';
import {FileTransferObject} from '@ionic-native/file-transfer';
//import {FileTransfer, FileUploadOptions, FileTransferObject} from '@ionic-native/file-transfer';
import {File} from '@ionic-native/file';


@Injectable()
export class PaybookRepo {

    TPaymentJoin: any = [TPaymentFlag.cpRealizado, TPaymentFlag.cpEstornado, TPaymentFlag.cpChargeback];

    constructor(public util: Util) {

    }

    consumoDebt(paybook, index): number {

        let debt = 0;
        paybook.Consumos.forEach((CS, indexCS) => {
            let bool = (CS.Consumo.ConsumoFlag == TConsumoFlag.cfLancado && (index == null || index == indexCS));
            
            //SYNC
          //if (bool) debt += (CS.Consumo.ConsumoQtde * (CS.Consumo.ConsumoCash - CS.Consumo.ConsumoLess));
            
            //DESK
            if (bool) debt += (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) - CS.Consumo.ConsumoLess;
        });

        return debt;

    }

    parcelaDebt(paybook, index, vencido?): number {

        let debt = 0;
        paybook.Parcelas.forEach((PL, indexPL) => {
            if (index == null || index == indexPL) {
                let hoje = this.util.dateHoje();
                let data = this.util.strToDate(PL.ParcelaData);
                let cash = PL.ParcelaCash;
                let pago = this.util.jsSum(PL.Payjoins, ['Payments', 'PaymentCash'], 'PaymentFlag', this.TPaymentJoin);
                if (vencido && cash > pago && data < hoje) debt = debt + (cash - pago);
                if (!vencido && cash > pago)               debt = debt + (cash - pago);
            }
        });

        return (debt > 0 ? debt : 0);

    }

    parcelaAgio(paybook, index) {

        let onAgio = (date) => {
            paybook.Parcelas[index].ParcelaAgio = date;
            //this.parcelaSave();
        };

        let selected = 0;
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativar', value: ''});

        let hoje = this.util.dateHoje();
        let agio = this.util.strToDate(paybook.Parcelas[index].ParcelaAgio);
        if (agio < hoje) {
            selected = 1;
            let sema = this.util.semana(this.util.dateToStr(agio), true).toUpperCase();
            let dstr = this.util.dataft(this.util.dateToStr(agio));
            buttons.push({text: sema + ' • ' + dstr, value: this.util.dateToStr(agio)});
        }

        for (let i = 1; i <= 7; i++) {
            hoje.setDate(hoje.getDate() + 1);
            if (agio == hoje) selected = i + 1;
            let sema = this.util.semana(this.util.dateToStr(hoje), true).toUpperCase();
            let dstr = this.util.dataft(this.util.dateToStr(hoje));
            buttons.push({text: sema + ' • ' + dstr, value: this.util.dateToStr(hoje)});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = selected;
        this.util.pickerOpen(columns, onAgio);

    }

}

@Injectable()
export class PaymentRepo {

    config: any = CONFIG;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    constructor(public util: Util,

                private webIntent: WebIntent,
                private transfer: FileTransferObject,
                private file: File,
                
                ) {

    }





    //# EXEMPLE INTENT
    googleMapsIntent() {

        // GOOGLE MAPS # INTENT # EXEMPLE
        const options = {
            action: this.webIntent.ACTION_VIEW, 
            url: 'geo:23.5264055,148.1594006', 
            package: 'com.google.android.apps.maps',
        }
        let onOkay = (okay) => alert('onOKEY:' + JSON.stringify(okay));
        let onErro = (erro) => alert('onERRO:' + JSON.stringify(erro));
        this.webIntent.startActivity(options).then(onOkay, onErro);

    }



    // ELGINPAY
    settingZera() {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.CUSTOM',
            package: 'com.elgin.e1.digitalhub',
            extras: {grupo: 'clear'},
        };
            
        let onOkay = (data) => alert(JSON.stringify(data));
        let onErro = (erro) => alert(JSON.stringify(erro));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    settingNome() {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.TEF',
            package: 'com.elgin.e1.digitalhub',
            extras: {funcao: 'configurar',
                        nome: 'LOREAN',
                        versao: '5.X',
                        textoPinpad: 'LOREAN',
                        macPinpad: '',
                        estabelecimento: this.monitorAuth.Hotspot.Branded.BrandedNome,
                        loja: 'Unidade',
                        terminal: 'Payout-01',
                },
        };
            
        let onOkay = (data) => alert(JSON.stringify(data));
        let onErro = (erro) => alert(JSON.stringify(erro));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    settingCnpj() {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.TEF',
            package: 'com.elgin.e1.digitalhub',
            extras: {funcao: 'ativar',
                    cnpjCpf: this.monitorAuth.Hotspot.Empresa.Profile.ProfileRnid,
                  //cnpjCpf: '09.304.838/0001-43',
                },
        };
            
        let onOkay = (data) => alert(JSON.stringify(data));
        let onErro = (erro) => alert(JSON.stringify(erro));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    settingHead() {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.CUSTOM',
            package: 'com.elgin.e1.digitalhub',
            extras: {grupo: 'header',
                    corIcone: this.config.colors.CorMilk,  //this.config.colors[this.config.negative(this.monitorAuth.Hotspot.Branded.BrandedCora)],
                    corBotao: this.config.colors.CorDash,  //this.config.colors[this.monitorAuth.Hotspot.Branded.BrandedCora],
                    corFonte: this.config.colors.CorMilk,  //this.config.colors[this.config.negative(this.monitorAuth.Hotspot.Branded.BrandedCora)],
                    //corFonteMensagem: this.config.colors.CorLime,
                },
        };
            
        let onOkay = (data) => alert(JSON.stringify(data));
        let onErro = (erro) => alert(JSON.stringify(erro));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    settingBody() {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.CUSTOM',
            package: 'com.elgin.e1.digitalhub',
            extras: {grupo: 'content',
                    corIcone: this.config.colors.CorMilk,  //this.config.colors[this.config.negative(this.monitorAuth.Hotspot.Branded.BrandedCora)],
                    corBotao: this.config.colors.CorDash,  //this.config.colors[this.monitorAuth.Hotspot.Branded.BrandedCora],
                    corFonte: this.config.colors.CorDash,  //this.config.colors[this.config.negative(this.monitorAuth.Hotspot.Branded.BrandedCora)],
                    corFonteMensagem: this.config.colors.CorDash,  //this.config.colors[this.config.negative(this.monitorAuth.Hotspot.Branded.BrandedCora, 'CorLime', 'CorDash')],
                },
        };
            
        let onOkay = (data) => this.settingLogo(data);
        let onErro = (erro) => alert(JSON.stringify(erro));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    settingLogo(tint?) {

        const options: IntentOptions = {
            action: 'com.elgin.e1.digitalhub.CUSTOM',
            package: 'com.elgin.e1.digitalhub',
            extras: {grupo: 'application',
                    logotipo: '/sdcard/Pictures/favicon.png',
                    background: this.config.colors.CorMilk,  //this.config.colors[this.monitorAuth.Hotspot.Branded.BrandedCora],
                },
        };
            
        let onOkay = (data) => alert('APLICATION:' + '<br>' + JSON.stringify(data) + '<br><br>' + 'CONTENT:' + '<br>' + JSON.stringify(tint));
        let onErro = (erro) => alert('APLICATION:' + '<br>' + JSON.stringify(erro) + '<br><br>' + 'CONTENT:' + '<br>' + JSON.stringify(tint));
        this.webIntent.startActivityForResult(options).then(onOkay, onErro);

    }

    prepareLogo() {

        if (!this.monitorAuth) {
            alert('NOT MonitorAuth');
            return;
        }

        let onOkay = (data) => this.settingLogo();
        let onErro = (erro) => alert(JSON.stringify(erro));

        // this.file.checkDir(this.file.externalRootDirectory, 'Pictures').then(_ => alert('Directory exists')).catch(err => alert('Directory not exist'));
        const url = this.monitorAuth.Hotspot.Branded.BrandedBase.split('?')[0];
        this.transfer.download(url, this.file.externalRootDirectory + 'Pictures/favicon.png').then(onOkay, onErro);

    }





    estornoSale(paymentNsun, paymentData, paymentCash: number): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let onErro = (erro) => {
                //NAO PODE TER ERRO PARA NAO OBRIGAR A COLOCAR O "SUBSCRIBE ERR"
                observer.error(erro);
                observer.complete();
            }
            
            let onOkay = (data) => {
                observer.next(data);
                observer.complete();
            }

            const options: IntentOptions = {
                action: 'com.elgin.e1.digitalhub.TEF',
                package: 'com.elgin.e1.digitalhub',
                extras: {funcao: 'cancelar',
                        data: paymentData, //"10/05/23" 
                        nsu: paymentNsun,
                        valor: paymentCash,
                        },    
            };

            this.webIntent.startActivityForResult(options).then(onOkay, onErro);

        });

    };
    
    paymentSale(paymentSide, paymentCash): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let onErro = (erro) => {
                //NAO PODE TER ERRO PARA NAO OBRIGAR A COLOCAR O "SUBSCRIBE ERR"
                observer.error(erro);
                observer.complete();
            }
            
            let onOkay = (data) => {
    
                //Corrige objeto que vem como string!
                data.extras.CODRESP = parseInt(data.extras.CODRESP); // #OKEY: Positivo e Zero  | #ERRO: Negativo!
                data.extras.COMP_DADOS_CONF = this.util.jsParse(data.extras.COMP_DADOS_CONF);
                //data.extras.retorno = this.util.jsParse(data.extras.retorno);
                //data.extras.retorno.resultado = this.util.jsParse(data.extras.retorno.resultado);

                observer.next(data);
                observer.complete();
    
                //OKAY
                // let x = {extras: {
                //             CODRESP: 0,
                //             COMP_DADOS_CONF: {
                //                                  administradora: 'Visa',
                //                                  autorizacao: '174920',
                //                                  cnpjRede: '01.425.787/0001-04',
                //                                  data: '20/09/2023 14:34:29.254',
                //                                  mensagem: 'Transacao aprovada',
                //                                  nsu: '268914',
                //                                  nsuRede: '201749201',
                //                                  numeroCartao: '498408******6070',
                //                                  pagamento: 'Parcelado', //'A vista',
                //                                  parcelas: '3',
                //                                  rede: 'Userede',
                //                                  tipoCartao: 'Credito', //'Debito',
                //                                  valor: '1.23',
                //                                  vencimento: '20/10/2023 14:34:23.978',
                //                                  viaCliente: '/\\/\\/\\/\\/ 09.304.838/0001-43 \\/\\/\\/\\/\\\r\n\r\n               REDECARD               \r\n             VISA CREDITO             \r\nCOMPR:201749211    VALOR:         1,23\r\nESTAB:                        99991234\r\n20/09/23-17:49:21 TERM:PV199999/268914\r\nNUM. PARCEL.    0 PARCEL.         0,00\r\nENC.MENS(%) 10,00 VAL.TOT         1,23\r\n                                      \r\nCARTAO: ************6070\r\nAUTORIZACAO: 174920\r\nARQC:\r\n   TRANSACAO APROVADA PELO EMISSOR    \r\n                                      <MSG_REM>\r\n\r\n\r\n--------------------------------------\r\n           Redecard Via Caixa        \r\n\r\n           Promocao 12345678       \r\n\r\n        Seu numero: 123456789        \r\n\r\n--------------------------------------\r\n</MSG_REM>\r\n/\\/\\/\\/\\/ 09.304.838/0001-43 \\/\\/\\/\\/\\\r\n',
                //                                  viaEstabelecimento: '/\\/\\/\\/\\/ 09.304.838/0001-43 \\/\\/\\/\\/\\\r\n\r\n               REDECARD               \r\n             VISA CREDITO             \r\nCOMPR:201749211    VALOR:         1,23\r\nESTAB:                        99991234\r\n20/09/23-17:49:21 TERM:PV199999/268914\r\nNUM. PARCEL.    0 PARCEL.         0,00\r\nENC.MENS(%) 10,00 VAL.TOT         1,23\r\n                                      \r\nCARTAO: ************6070\r\nAUTORIZACAO: 174920\r\nARQC:\r\n   TRANSACAO APROVADA PELO EMISSOR    \r\n                                      <MSG_REM>\r\n\r\n\r\n--------------------------------------\r\n           Redecard Via Caixa        \r\n\r\n           Promocao 12345678       \r\n\r\n        Seu numero: 123456789        \r\n\r\n--------------------------------------\r\n</MSG_REM>\r\n/\\/\\/\\/\\/ 09.304.838/0001-43 \\/\\/\\/\\/\\\r\n',
                //                                  viaSMS: '[VENDA] Credito A vista * Cartao Final 6070 * 20/09/2023 14:34:29 * DOC 268914 * R$ 1,23',
                //                              },
                //             resultCode: -1,
                //             requestCode: 1,
                //             retorno: {  funcao: 'vender',
                //                         mensagem: 'Sucesso',
                //                         resultado: null //<--- é igual ao COMP_DADOS_CONF
                //                     },
                //             },
                //         flags: 0,
                //         }
    
                //ERRO!
                // let x = {extras: {
                //             CODRESP: 0,
                //             COMP_DADOS_CONF: {mensagem: 'TRANSACAO CANCELADA/NÃO CONCLUIDA - [-5]'},
                //             resultCode: -1,
                //             requestCode: 1,
                //             retorno: {  funcao: 'vender',
                //                         mensagem: 'Sucesso',
                //                         resultado: {mensagem: 'TRANSACAO CANCELADA/NÃO CONCLUIDA - [-5]'}
                //                     },
                //             },
                //         flags: 0,
                //         }
                        
            };

            const options: IntentOptions = {
                action: 'com.elgin.e1.digitalhub.TEF',
                package: 'com.elgin.e1.digitalhub',
                // url: 'path/to/file',
                // type: 'application/vnd.android.package-archive'

                extras: {funcao: (paymentSide == TFinanceSide.cdTodos ? 'pix' : (paymentSide == TFinanceSide.cdCredito ? 'credito' : 'debito')),
                        valor: paymentCash.toFixed(2),
                        parcelas: '1',      //0-A Vista;
                        financiamento: '1', //1-A Vista; 2-Emissor; 3-Estabelecimento
                        },
    
                // extras: {funcao: 'debito',
                //         valor: '10.90'},
    
                // extras: {funcao: 'pix',
                //         valor: '10.90'},

                // #Pede todas informacoes no IDH da Elgin
                // extras: {funcao: 'vender'},

            };

            this.webIntent.startActivityForResult(options).then(onOkay, onErro);
                
        });
        
    }

}



// WEBPACK FOOTER //
// ./src/repositories/payment-repo.ts